const expiredListeners = new Set();
let sessionExpiredEmitted = false;

export function onSessionExpired(listener) {
  expiredListeners.add(listener);
  return () => expiredListeners.delete(listener);
}

export function notifySessionExpired() {
  if (sessionExpiredEmitted) {
    return;
  }
  sessionExpiredEmitted = true;
  expiredListeners.forEach((listener) => listener());
}

export function resetSessionExpiredNotification() {
  sessionExpiredEmitted = false;
}
